// extracted by mini-css-extract-plugin
module.exports = {"background":"bg_fl","shopping__wrapper__examples":"bg_fm","active":"bg_fn","shopping__wrapper__project":"bg_fp"};